import startCase from 'lodash/startCase';

export function subscriptionStatusLabel(
  status?: string | null,
  statusLabel?: string | null,
): string {
  return statusLabel || startCase(status || '');
}
